export const blues = {
  Blue000: "#ECF1F6",
  Blue100: "#DAE3ED",
  Blue200: "#9CC7F0", // focus
  Blue300: "#5882B0",
  Blue400: "#4675A8",
  Blue500: "#3F6997",
  Blue600: "#5B6C7F",
  Blue700: "#475A6F",
  Blue800: "#34485E",
  Blue900: "#0094FF",
  Blue1000: "#0021DC",
};

export const brand = {
  Aqua: "#13D8E6",
  Navy: "#106992",
  PlatformBlue: "#34485E", // SAME AS Blue800
  Teal: "#2F6474",
  TrustBlue: "#54BCEB",
};

export const greens = {
  Green000: "#F1F7EA",
  Green100: "#72B553",
  Green200: "#00D400",
};

export const greys = {
  Grey050: "#E2E2E2",
  Grey000: "#EEEEEE",
  Grey100: "#F5F5F5",
  Grey200: "#D8D8D8",
  Grey300: "#CCCCCC",
  Grey400: "#BBBBBB",
  Grey500: "#999999",
  Grey600: "#333333",
  Grey700: "#7E8C8D",
  Grey800: "#777777",
  Grey900: "#454545",
  Grey1000: "#232323",
};

export const orange = {
  Orange000: "#F06C00",
  Orange100: "#F37C22",
};

const pinks = {
  Pink000: "#F230A3",
};

const purples = {
  Purple000: "#B140FF",
};

export const reds = {
  Red000: "#FCE8E6",
  Red100: "#C60009",
  Red200: "#971307",
  Red300: "#542600",
  Red400: "#EA3523",
};

export const white = {
  White: "#FFFFFF",
};

export const yellows = {
  Yellow000: "#FFF6E5",
  Yellow100: "#FFAE00",
  Yellow200: "#FEC20F",
};

export default {
  ...blues,
  ...brand,
  ...greens,
  ...greys,
  ...orange,
  ...pinks,
  ...purples,
  ...reds,
  ...white,
  ...yellows,
};

export const code = `
  import { Colors } from "design-system";
  const myColor = Colors.Blue000;
`;

export const chartColors = {
  Pink: pinks.Pink000,
  Gold: yellows.Yellow200,
  Violet: purples.Purple000,
  Sky: blues.Blue900,
  Lime: greens.Green200,
  Auburn: reds.Red300,
  Orange: orange.Orange100,
  Slate: greys.Grey700,
  Indigo: blues.Blue1000,
  Crimson: reds.Red400,
};

export const brandingColors = {
  DarkBackground: greys.Grey900,
  Hover: greys.Grey1000,
  ActiveItem: greys.Grey800,
  // Accent: purples.Purple000, // restore when design system is updated
  Accent: blues.Blue400,

  LightBackground: greys.Grey050,
  Text: greys.Grey800,
};
